import React from 'react';
import { Link } from 'react-router-dom';
import CourseCard from '../components/CourseCard';
import FeatureTable from '../components/FeatureTable';
import ServicesScroller from '../components/ServicesScroller';

const Home = () => {
  const courses = [
    {
      id: 'salesforce-platform-developer',
      title: 'PD1 (Platform Developer 1)',
      // price: '₹44,999',
      // originalPrice: '₹49,999',
      features: [
        'AI-Powered Learning Modules',
        'Naukri Profile Enhancement',
        'Resume Building Support',
        'LinkedIn Branding',
        'Free Portfolio Website',
        'Weekly Assessments & Tests',
        'Mock Interviews',
        'No Code / Low Code / Code Training'
      ],
      duration: '3 Months + 1 Month Projects',
      placement: '100% Job Placement Assistance',
      tagline: 'Most Popular Choice',
      isRecommended: true
    },
    {
      id: 'salesforce-business-analyst',
      title: 'BA (Business Analyst)',
      // price: '₹42,999',
      // originalPrice: '47,999',
      features: [
        'AI-Powered Learning Modules',
        'Naukri Profile Enhancement',
        'Resume Building Support',
        'LinkedIn Branding',
        'Free Portfolio Website',
        'Weekly Assessments & Tests',
        'Mock Interviews',
        'No Code / Low Code / Code Training'
      ],
      duration: '3 Months + 1 Month Projects',
      placement: '100% Job Placement Assistance',
      tagline: 'For Non-Technical Professionals'
    },
    {
      id: 'salesforce-lwc-developer',
      title: 'LWC (Lightning Web Components)',
      // price: '₹19,999',
      // originalPrice: '₹24,999',
      features: [
        'AI-Powered Learning Modules',
        'Naukri Profile Enhancement',
        'Resume Building Support',
        'Weekly Assessments & Tests',
        'Mock Interviews',
        'No Code / Low Code / Code Training',
        'Intensive Hands-on Projects'
      ],
      duration: '45 Days Intensive',
      placement: 'Based On Performance',
      tagline: 'Fast-Track Specialization'
    }
  ];

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <h1>Become a <span>Software Professional & Get High Salary</span></h1>
          <p>🚀 Most Popular Salesforce Courses – Learn. Build. Get Hired.</p>
          <div className="hero-buttons">
            <Link to="/courses" className="cta-button">Explore Courses</Link>
            <Link to="/contact" className="secondary-button">Speak to Counselor</Link>
          </div>
        </div>
      </section>

      <div>
      {/* Other Sections */}
      <ServicesScroller />
      {/* Other Sections */}
    </div>

      {/* Courses Section */}
      <section className="courses" id="courses">
        <div className="container">
          <div className="section-header">
            <h2>Choose from Our Top Salesforce Career Tracks</h2>
            <p>Comprehensive training programs designed to make you job-ready</p>
          </div>
          <div className="course-tracks-container">
            {courses.map(course => (
              <div 
                key={course.id} 
                className={`course-wrapper ${course.isRecommended ? 'recommended' : ''}`}
              >
                {course.isRecommended && (
                  <div className="recommended-badge">Recommended</div>
                )}
                <CourseCard course={course} />
                <p className="course-tagline">{course.tagline}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

   

      {/* Features Comparison */}
      <section className="features" id="features">
        <div className="container">
          <div className="section-header">
            <h2>Detailed Course Comparison</h2>
            <p>See how our different Salesforce tracks compare to find your perfect fit</p>
          </div>
          <FeatureTable />
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2>Ready to Launch Your Salesforce Career?</h2>
          <p>Join hundreds of students who have transformed their careers with our Salesforce Developer programs</p>
          <Link to="/enroll" className="secondary-button">Enroll Now</Link>
                      {/* <Link to="/enroll" >Enroll Now </Link> */}
          
        </div>
      </section>
    </div>
  );
};

export default Home;